import React from 'react';
import { Grid, Typography } from '@material-ui/core/';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles({
  main: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  labelStyle: {
    flexGrow: 1,
    maxWidth: '100%'
  },
  errorText: {
    color: '#f44336', // Material-UI error color
    fontSize: '0.75rem',
    marginLeft: '8px'
  }
});

const getIsChecked = input => {
  return input.checked;
};

const CheckBoxField = ({
  input,
  label,
  meta,
  basePath,
  isChecked = getIsChecked,
  classesOverride,
  ...custom
}) => {
  const classes = useStyles();
  const showError = meta.touched && meta.error;

  return (
    <Grid
      container
      spacing={0}
      className={clsx(classesOverride && classesOverride.main, classes.main)}
    >
      <Grid item>
        <Checkbox
          {...input}
          {...custom}
          checked={isChecked(input)}
          value={`${input.value}`}
          id={`checkbox-${label}`}
        />
      </Grid>
      <Grid
        item
        xs={6}
        sm={6}
        md={6}
        lg={6}
        xl={true}
        className={classes.labelStyle}
      >
        <Typography variant="caption">{label}</Typography>
      </Grid>
      {showError && (
        <Grid item xs={12}>
          <Typography className={classes.errorText}>{meta.error}</Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default CheckBoxField;
